<div [@dialog] *ngIf="visible" class="dialog">
  <h2>{{putTemplateHeader}}</h2>
  <div class="inner">
    <div class="form_wrapper">
      <p *ngIf="!fields || !fields.length">No fields defined.</p>
      <form *ngIf="fields && fields.length" class="pure-form pure-form-aligned" [formGroup]="myForm" (ngSubmit)="submit($event);">
        <fieldset>
          <field-input [field]="field" [form]="myForm" [requestHeaders]="requestHeaders"
                       [workingRowData]="workingRowData" [methodDataPath]="methodData.dataPath"
                       *ngFor="let field of fields"
                       class="pure-control-group">
          </field-input>
          <div class="center">
            <button type="submit" class="pure-button pure-button-primary button-large" [disabled]="myForm.invalid || submited">Submit</button>
          </div>
          <app-loader [size]="'small'" [loading]="loading"></app-loader>
        </fieldset>
        <div class="progress" *ngIf="progress > 0">
          <div class="progress-bar progress-bar-animated progress-bar-striped bg-success" role="progressbar" [style.width.%]="progress">{{progress}}%</div>
        </div>
      </form>
    </div>
    <button *ngIf="closable && !loading" (click)="close()" aria-label="Close" class="dialog__close-btn button1"><i class="fa fa-times">close</i></button>
  </div>
</div>

<div *ngIf="visible" class="overlay" ></div>
